import React, {Component} from 'react'

class Footer extends Component {
    render() {
        return <footer>
                    <span>Copyright © {(new Date().getFullYear())} Association Analytics. All Rights Reserved.</span>
                    {/* <a href="/shared/contact">Contact Us</a> */}
                </footer>               
                                
    }
}

export default Footer


// WEBPACK FOOTER //
// ./src/Components/Shared/Footer.js